(ns yardwerkz.web.realtime
  "Real-time subscription hooks for web screens.
   Copied from frontend/src/yardwerkz/realtime.cljs — namespace refs updated."
  (:require
   [uix.core :refer [use-effect use-callback]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [lambdaisland.glogi :as log]))

;; =============================================================================
;; Core Hook
;; =============================================================================

(defn use-subscription
  "Core subscription hook. Dispatches RFX events for lifecycle management.
   Skips subscription if id is nil."
  [type id]
  (let [skip? (nil? id)
        sub-id (str (name type) ":" id)
        dispatch (rfx/use-dispatch)
        sub-state (rfx/use-sub [::store/subscription-data sub-id])

        refresh! (use-callback
                  (fn []
                    (when-not skip?
                      (dispatch [::store/realtime-subscribe
                                 {:sub-id sub-id :type type :id id}])))
                  [skip? sub-id type id dispatch])]

    (use-effect
     (fn []
       (if skip?
         js/undefined
         (do
           (dispatch [::store/realtime-subscribe
                      {:sub-id sub-id :type type :id id}])
           (fn []
             (dispatch [::store/realtime-unsubscribe sub-id])))))
     [skip? sub-id type id dispatch])

    (if skip?
      {:data nil :loading? false :error nil :refresh! refresh!}
      (-> (or sub-state {:data nil :loading? true :error nil})
          (assoc :refresh! refresh!)))))

;; =============================================================================
;; Entity Hooks
;; =============================================================================

(defn use-job [job-id]
  (use-subscription :entity/job job-id))

(defn use-quote [quote-id]
  (use-subscription :entity/quote quote-id))

(defn use-property [property-id]
  (use-subscription :entity/property property-id))

(defn use-yard [yard-id]
  (use-subscription :entity/yard yard-id))

;; =============================================================================
;; Topic Hooks
;; =============================================================================

(defn use-customer-jobs [customer-id]
  (use-subscription :topic/customer-jobs customer-id))

(defn use-job-quotes [job-id]
  (use-subscription :topic/job-quotes job-id))

(defn use-job-messages [job-id]
  (use-subscription :topic/job-messages job-id))

(defn use-customer-properties [customer-id]
  (use-subscription :topic/customer-properties customer-id))

(defn use-property-yards [property-id]
  (use-subscription :topic/property-yards property-id))

(defn use-services []
  (use-subscription :topic/services :all))

(defn use-job-tracking [job-id]
  (use-subscription :topic/job-tracking job-id))

(defn use-unread-count [account-id]
  (use-subscription :topic/unread-count account-id))

(defn use-notifications [account-id]
  (use-subscription :topic/notifications account-id))
